<template>
    <div :key="key" class="ma-3">
        <!-- Desktop View -->

        <!-- Filters -->
        <v-row class="d-flex mb-2">
            <v-col cols="2">
                <v-btn-primary block @click="addZTillDialog = true" size="large">
                    {{ $t("ztill.ajouter") }}
                </v-btn-primary>
            </v-col>
            <v-col cols="2" class="px-1">
                <v-row style="background-color: #fff; border-radius: 15px" class="mx-1" no-gutters>
                    <v-col>
                        <oss-text-field
                            v-model="minAmount"
                            label="Min"
                            color="secondary"
                            min="0"
                            hide-details
                        />
                    </v-col>
                    <v-col cols="1" class="d-flex align-center justify-end">
                        <v-icon size="7px">$oss-chevron-left</v-icon>
                    </v-col>
                    <v-col>
                        <oss-text-field
                            v-model="maxAmount"
                            label="Max"
                            color="secondary"
                            min="0"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="2" class="px-1">
                <v-select
                    outlined
                    :label="$t('ztill.period')"
                    v-model="period"
                    :items="allZtillPeriods"
                    item-value="value"
                    item-title="title"
                    hide-details
                    density="compact"
                />
            </v-col>
            <v-col cols="3" class="px-1">
                <oss-date-range-picker
                    :begin="beginDate"
                    :end="endDate"
                    bg-color="white"
                    hide-details
                    dense
                    @change-dateRange="onDateRangeChanged"
                />
            </v-col>
            <v-col cols="1" class="d-flex align-center px-1">
                <v-btn-icon icon="$delete" @click="clearFilter()" color="secondary" />
            </v-col>
        </v-row>

        <!-- OSS Cards -->
        <v-data-table-server
            :items="items"
            :page="pagination.page"
            :sort-by="pagination.sortBy"
            :sort-desc="pagination.descending"
            :items-per-page="pagination.rowsPerPage"
            :items-length="pagination.totalItems"
            :items-per-page-options="[5, 10, 25]"
            :loading="loading"
            class="table"
            hide-default-footer
            fixed-header
            height="70vh"
            style="min-width: 800px"
        >
            <template #headers>
                <tr>
                    <th colspan="12">
                        <v-row no-gutters class="d-flex justify-end">
                            <v-col cols="5" class="d-flex justify-end align-center">
                                <v-select
                                    v-model="pagination.rowsPerPage"
                                    :items="[5, 10, 25]"
                                    hide-details
                                    outlined
                                    style="font-size: 0.75rem; width: min-content"
                                    width="30px"
                                    prefix="Lignes par page"
                                    density="compact"
                                />
                                <span style="white-space: nowrap">
                                    {{ (pagination.page - 1) * pagination.rowsPerPage + 1 }} -
                                    {{
                                        (pagination.page - 1) * pagination.rowsPerPage +
                                        pagination.rowsPerPage
                                    }}
                                    de {{ pagination.totalItems }}
                                </span>
                                <v-btn-prev
                                    @click="pagination.page--"
                                    :disabled="pagination.page === 1"
                                    size="small"
                                />
                                <v-btn-next
                                    @click="pagination.page++"
                                    size="small"
                                    :disabled="nextPageDisabled"
                                />
                            </v-col>
                        </v-row>
                    </th>
                </tr>
            </template>

            <template v-slot:no-data>
                <v-row class="py-3" @click="addZTillDialog = true">
                    <v-col cols="12" class="d-flex justify-center">
                        {{ $t("ztill.aucun") }}
                    </v-col>
                    <v-col cols="12" class="py-3">
                        <v-btn-primary>
                            {{ $t("ztill.ajouter") }}
                        </v-btn-primary>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item="{ item }">
                <tr style="cursor: pointer" @click="openTicketZ(item)">
                    <td class="text-left">
                        <v-icon color="secondary" size="small">$oss-calendar</v-icon>
                        {{ getSubTitle(item) }}
                        <v-icon
                            color="primary"
                            class="spacer-left-small"
                            v-if="haveFile(item)"
                            size="small"
                            >$oss-paper-clip</v-icon
                        >
                        <v-icon
                            color="secondary"
                            class="spacer-left-small"
                            v-if="item.uniqueExport && item.uniqueExport.id"
                            size="small"
                            >$oss-download</v-icon
                        >
                    </td>
                    <td class="text-left">
                        {{ getDateFormated(item) }}
                    </td>
                    <td class="text-right">
                        HT: {{ newCommonFormatCurrency(item.netAmount, undefined) }}
                    </td>
                    <td class="text-right">
                        TVA : {{ newCommonFormatCurrency(item.vatAmount, undefined) }}
                    </td>
                    <td class="text-right">
                        <b>{{ newCommonFormatCurrency(item.grossAmount, undefined) }}</b>
                    </td>
                    <td class="text-center">
                        <v-btn
                            color="white"
                            icon="$delete"
                            @click.stop="((zTillToDelete = item), (deleteDialog = true))"
                            v-if="enableDelete(item)"
                        />
                    </td>
                </tr>
            </template>
        </v-data-table-server>
        <DocumentWizardDialog
            v-model="addZTillDialog"
            :companyId="selectedCompany.id"
            :showFirstPrevious="false"
            :inGlobalStep="'zTillReceipt'"
            @created="onZTillReceiptCreated"
            v-if="addZTillDialog"
        />
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="zTillToDelete = null"
            @valid="deleteZTill"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer ce z de caisse ?</h4>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { State2Way } from "@/decorators";
import { User } from "../../store/store";
import { Apollo } from "@/decorators";

import DELETE_ZTILL from "../../graphql/DeleteZTill.gql";
import ZTILLRECEIPTS_FILTER_QUERY from "../../graphql/FilterZtillReceipts.gql";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import DocumentWizardDialog from "../document/DocumentWizardDialog.vue";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../../services/dateServices";
import { isInsideClosedAccountingPeriod } from "../../services/accountingPeriods";
import { Component, Vue, toNative, Watch } from "vue-facing-decorator";

@Component({
    components: {
        DocumentWizardDialog,
    },
})
export class TicketZTable extends Vue {
    zTillToDelete = null;
    deleteDialog = false;
    deleteLoading = false;

    addZTillDialog = false;

    key = 0;

    get loading() {
        if (this.$apollo.queries.items) {
            return this.$apollo.queries.items.loading;
        }
        return false;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get nextPageDisabled() {
        return (
            Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) <=
            this.pagination.page
        );
    }

    // @Apollo({
    //     query: TICKETSZ,
    //     variables() {
    //         return {
    //             companyId: this.selectedCompany.id
    //         }
    //     },
    //     skip() {
    //         return !this.selectedCompany.id
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data) {
    //                 this.items = data.zTillReceipts
    //             }
    //         }
    //     }
    // })
    // items: Array<any> = []

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    openTicketZ(item: any) {
        this.$router.push({
            name: "zTillReceipt",
            params: {
                companyId: this.selectedCompany.id,
                id: item.id,
            },
        });
    }

    getDateFormated(item) {
        if (item.period === "WE") {
            const start = moment(item.date).startOf("week");
            return (
                "Du " +
                start.format("DD MMM YYYY") +
                " au " +
                moment(item.date).format("DD MMM YYYY")
            );
        }
        if (item.period === "MO") {
            const start = moment(item.date).startOf("month");
            return (
                "Du " +
                start.format("DD MMM YYYY") +
                " au " +
                moment(item.date).format("DD MMM YYYY")
            );
        }
        if (item.date) return moment(item.date).format("DD MMM YYYY");
        return "";
    }

    getPeriod(period) {
        if (period) {
            switch (period) {
                case "AM":
                    return this.$t("ztill.matin");
                case "PM":
                    return this.$t("ztill.apres-midi");
                case "DA":
                    return this.$t("ztill.journee");
                case "WE":
                    return this.$t("ztill.semaine");
                case "MO":
                    return this.$t("ztill.mois");
            }
        }
        return this.$t("ztill.period-inconnue");
    }

    get allZtillPeriods() {
        const allPeriods = [
            { value: "AM", title: this.getPeriod("AM") },
            { value: "PM", title: this.getPeriod("PM") },
            { value: "DA", title: this.getPeriod("DA") },
            { value: "WE", title: this.getPeriod("WE") },
            { value: "MO", title: this.getPeriod("MO") },
            { value: "UNKNOWN", title: this.getPeriod("UNKNOWN") },
        ];
        return allPeriods;
    }

    getSubTitle(item) {
        let subTitle = this.getPeriod(item.period);
        if (item.accountingItemImport) {
            subTitle += " - Importé";
        }
        return subTitle;
    }

    enableDelete(zTillReceipt: any) {
        // if (!zTillReceipt) return false;
        // if (zTillReceipt.documents) {
        //     for (const doc of zTillReceipt.documents) {
        //         if (doc.vatDeclaration) return false;
        //     }
        // }
        // if (zTillReceipt.accountingItemImport) {
        //     return false
        // }
        if (isInsideClosedAccountingPeriod(this.$store, zTillReceipt.date)) return false;
        return true;
    }

    async deleteZTill() {
        this.deleteLoading = true;
        if (this.zTillToDelete) {
            const index = this.items.findIndex((x) => x.id === this.zTillToDelete.id);
            await this.$apollo.mutate({
                mutation: DELETE_ZTILL,
                variables: {
                    zTillId: this.zTillToDelete.id,
                },
            });
            if (index !== -1) {
                this.items.splice(index, 1);
            }
        }
        this.deleteLoading = false;
        this.deleteDialog = false;
    }

    onZTillReceiptCreated() {
        if (this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        }
    }

    clearFilter() {
        this.minAmount = "";
        this.maxAmount = "";
        this.beginDate = "";
        this.endDate = "";
        this.period = "";
    }

    onDateRangeChanged(data) {
        this.beginDate = data.begin;
        this.endDate = data.end;
    }

    // Filters stored in store
    @State2Way("updateZtillReceiptsBeginDate", "ztillReceiptsFilter.date.begin")
    beginDate!: string;

    @State2Way("updateZtillReceiptsEndDate", "ztillReceiptsFilter.date.end")
    endDate!: string;

    @State2Way("updateZtillReceiptsMinAmount", "ztillReceiptsFilter.amount.minimum")
    minAmount!: string;

    @State2Way("updateZtillReceiptsMaxAmount", "ztillReceiptsFilter.amount.maximum")
    maxAmount!: string;

    @State2Way("updateZtillReceiptsPeriod", "ztillReceiptsFilter.period")
    period!: string;

    @State2Way("updateZtillReceiptsPagination", "ztillReceiptsFilter.pagination")
    pagination!: any;

    @State2Way("updateAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    beforeMount() {
        this.onAccountingPeriodChanged(this.selectedAccountingPeriod, undefined);
    }

    @Watch("selectedAccountingPeriod")
    onAccountingPeriodChanged(value, prevValue) {
        if (value) {
            if (!this.beginDate) {
                this.beginDate = moment(value.start).format("YYYY-MM-DD");
            } else {
                const mBegin = moment(this.beginDate);
                if (mBegin.isBefore(moment(value.start)) || mBegin.isAfter(moment(value.end))) {
                    this.beginDate = moment(value.start).format("YYYY-MM-DD");
                }
            }
            if (!this.endDate) {
                this.endDate = moment(value.end).format("YYYY-MM-DD");
            } else {
                const mEnd = moment(this.endDate);
                if (mEnd.isAfter(moment(value.end)) || mEnd.isBefore(moment(value.start))) {
                    this.endDate = moment(value.end).format("YYYY-MM-DD");
                }
            }
        }
    }

    @Apollo({
        query: ZTILLRECEIPTS_FILTER_QUERY,
        variables() {
            return {
                minAmount: this.minAmount.length > 0 ? parseFloat(this.minAmount) : undefined,
                maxAmount: this.maxAmount.length > 0 ? parseFloat(this.maxAmount) : undefined,
                beginDate: getDBFormattedStartDate(this.beginDate),
                endDate: getDBFormattedEndDate(this.endDate),
                period: this.period.length > 0 ? this.period : undefined,
                companyId: this.selectedCompany.id,
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
            };
        },
        fetchPolicy: "network-only",
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.items = data.zTillReceipts;
                debugger;
                this.pagination.totalItems = data.zTillReceiptsConnection.aggregate.count;
            }
        },
    })
    items: any[] = [];

    onIntersect(entries, observer) {
        if (entries[0].isIntersecting) {
            this.pagination.rowsPerPage += 10;
        }
    }

    @Watch("selectedCompany")
    change() {
        this.items = [];
    }

    haveFile(item: any) {
        return !!item?.originalDocument?.original?.id;
    }
}

export default toNative(TicketZTable);
</script>
<style>
.spacer-left-small {
    margin-left: 5px;
}
</style>
